import { PosTable } from "../utilities/types";

// Same host as lightService — the local middleware, never the POS bridge directly.
// This app never holds POS credentials or knows the bridge's own address; the
// middleware resolves both from its synced config.
const MIDDLEWARE_BASE_URL = "http://localhost:9378";

// Deliberately short: this only gates whether the Stop flow shows a billing
// picker at all. If the middleware or the POS bridge is slow/unreachable, we'd
// rather skip billing than make the person ending a session wait on it.
const POS_TABLES_TIMEOUT_MS = 1500;

export const posService = {
  /**
   * Fetches the venue's POS tables (via the middleware's /pos/tables proxy) for
   * the Stop billing picker. Always resolves — never throws — because "the POS
   * is unreachable" and "there are no tables" should be handled identically by
   * the caller: skip the billing step and just stop the session.
   */
  async fetchTables(): Promise<PosTable[]> {
    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), POS_TABLES_TIMEOUT_MS);

    try {
      const response = await fetch(`${MIDDLEWARE_BASE_URL}/pos/tables`, {
        signal: controller.signal,
      });
      if (!response.ok) return [];
      const data = await response.json();
      return Array.isArray(data) ? data : [];
    } catch {
      // Timed out, middleware not running, or POS bridge unreachable.
      return [];
    } finally {
      window.clearTimeout(timeoutId);
    }
  },
};
